import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {AnalyticsService} from "../../../../commons/services/analytics-service.service";
import {AccountModel} from "../../../../account/angular/models/account.model";

export class ReportsAllFiltersPanelCtrl implements IController {

  branchId: any;
  demandIds: any;
  supplyId: any;
  agentIds: any;
  tagNames: any;
  onFiltersChange: Function;

  /* @ngInject */
  constructor(private $mdPanel, private splitService) {
  }

  $onInit() {
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.all-filters-panel')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          siteId: this.splitService.getSiteId(),
          branchId: this.branchId,
          demandIds: this.demandIds || [],
          supplyId: this.supplyId,
          agentIds: this.agentIds || [],
          tagNames: this.tagNames || [],
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: AllFiltersPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/reports/components/panels/reports-all-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      branchId: filterConfig.branchId,
      demandIds: filterConfig.demandIds,
      supplyId: filterConfig.supplyId,
      agentIds: filterConfig.agentIds,
      tagNames: filterConfig.tagNames
    })
  }


}

class AllFiltersPanelCtrl implements IController {

  private siteId: any;
  private configTimeZone: any;
  private filterConfig: any;

  constructor(private mdPanelRef, private analyticsService: AnalyticsService, private splitService, private moment, private $state) {
    this.siteId = this.mdPanelRef.config.locals.data.siteId;
    this.configTimeZone = this.splitService.getTimeZone();
  }

  $onInit() {
    this.filterConfig = {
      branchId: this.mdPanelRef.config.locals.data.branchId,
      demandIds: this.mdPanelRef.config.locals.data.demandIds,
      supplyId: this.mdPanelRef.config.locals.data.supplyId,
      agentIds: this.mdPanelRef.config.locals.data.agentIds,
      tagNames: this.mdPanelRef.config.locals.data.tagNames
    };
  }

  ///////////////////////////////////////////////////////////////////////////////////////

  // onDateChanged() {
  //     if (this.filterConfig.from > this.filterConfig.to) {
  //         this.filterConfig.to = angular.copy(this.filterConfig.from);
  //     }
  // }

  // onStartDateChange(selectedDate) {
  //   this.filterConfig.from = selectedDate;
  //   if (selectedDate > _.get(this.filterConfig, 'to')) {
  //     this.filterConfig.to = selectedDate;
  //   }
  // }
  //
  // onEndDateChange(selectedDate) {
  //   this.filterConfig.to = selectedDate;
  //   if (selectedDate < _.get(this.filterConfig, 'from')) {
  //     this.filterConfig.from = selectedDate;
  //   }
  // }

  onChangeBranchId(branchId) {
    this.filterConfig.branchId = branchId;
    this.filterConfig.demandIds = [];
  }

  onChangeDemandIds(demandIds) {
    this.filterConfig.demandIds = demandIds;
  }

  onChangeSupplyId(account: AccountModel) {
    this.filterConfig.supplyId = _.get(account, 'id');
    this.filterConfig.agentIds = [];
  }

  onChangeAgentIds(agentIds) {
    this.filterConfig.agentIds = agentIds;
  }

  onChangeTagNames(tagNames) {
    this.filterConfig.tagNames = tagNames;
  }


  onReset() {
    this.filterConfig = {
      branchId: undefined,
      demandIds: [],
      supplyId: undefined,
      agentIds: [],
      tagNames: []
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close()
      .then((mdPanelRef) => {
        const filterConfig = {
          branchId: this.filterConfig.branchId,
          demandIds: this.filterConfig.demandIds,
          supplyId: this.filterConfig.supplyId,
          agentIds: this.filterConfig.agentIds,
          tagNames: this.filterConfig.tagNames
        };
        this.mdPanelRef.config.locals.onClose(filterConfig, this.mdPanelRef.config.locals.data.parentScope);
        // this.$state.go('.', {from: from, to: to}, {notify: false, reload: false});
      })
  }

  cancel() {
    this.mdPanelRef.close();
  }

  // Change to a moment date:
  private _getDate(date) {
    return this.moment(this.moment(date).local().toISOString());
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsAllFiltersPanel', {
    bindings: {
      branchId: '<',
      demandIds: '<',
      supplyId: '<',
      agentIds: '<',
      tagNames: '<',
      onFiltersChange: '&'
    },
    template: require('./reports-all-filters-panel.html').default,
    controller: ReportsAllFiltersPanelCtrl
  });
